import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ThemeNestingExtend from './ThemeNestingExtend';
import ClientProvider from './client';
export default createDemo(import.meta.url, ThemeNestingExtend, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/theming/demos/theme-nesting-extend/ThemeNestingExtend.tsx",
    "fileName": "ThemeNestingExtend.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { createTheme, ThemeProvider } from '@mui/material/styles';\nimport type { Theme } from '@mui/material/styles';\nimport Checkbox from '@mui/material/Checkbox';\nimport { green, orange } from '@mui/material/colors';\n\nconst outerTheme = createTheme({\n  palette: {\n    secondary: {\n      main: orange[500],\n    },\n  },\n});\n\nexport default function ThemeNestingExtend() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={outerTheme}>\n      <Checkbox defaultChecked color=\"secondary\" />\n      <ThemeProvider\n        theme={(theme: Theme) =>\n          createTheme({\n            ...theme,\n            palette: {\n              ...theme.palette,\n              primary: {\n                main: green[500],\n              },\n            },\n          })\n        }\n      >\n        <Checkbox defaultChecked />\n        <Checkbox defaultChecked color=\"secondary\" />\n      </ThemeProvider>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 36,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { createTheme, ThemeProvider } from '@mui/material/styles';\nimport type { Theme } from '@mui/material/styles';\nimport Checkbox from '@mui/material/Checkbox';\nimport { green, orange } from '@mui/material/colors';\n\nconst outerTheme = createTheme({\n  palette: {\n    secondary: {\n      main: orange[500],\n    },\n  },\n});\n\nexport default function ThemeNestingExtend() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <ThemeProvider theme={outerTheme}>\n      <Checkbox defaultChecked color=\"secondary\" />\n      <ThemeProvider\n        theme={(theme: Theme) =>\n          createTheme({\n            ...theme,\n            palette: {\n              ...theme.palette,\n              primary: {\n                main: green[500],\n              },\n            },\n          })\n        }\n      >\n        <Checkbox defaultChecked />\n        <Checkbox defaultChecked color=\"secondary\" />\n      </ThemeProvider>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 36,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Checkbox",
      "@mui/material/colors"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
